import styled from 'styled-components'

export const SectionTitle = styled.h2`
  font-family: Lato;
  font-size: 24px;
  font-style: normal;
  font-weight: 300;
  line-height: 32px;
`
